import React, {
  useRef,
  useState,
  useEffect,
} from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import CustomHelmet from 'components/CustomHelmet';
import { useTranslation } from 'react-i18next';
import ScrollableContainerWrapper from 'components/ScrollableContainerWrapper';
import { selectLocale } from 'models/localization';
import { selectLocalizedEventName } from 'models/virtual_event';
import FloatingFooter from 'components/footer_v2/FloatingFooter';
import Routes from 'Routes';
import ParticipantListContainer from './ParticipantListContainer';

const RootContainer = styled.div`
  height: 100%;
  overflow: auto;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  -webkit-overflow-scrolling: touch;

  @media (min-width: 960px) {
    background-color: #F0F2F5;
  }

  @media (max-width: 960px) {
    background-color: #F0F1F2;
  }
`;

const PageContentContainer = styled.div`
  flex: 1 0 auto;
`;

const ParticipantPageContainer = () => {
  const { t } = useTranslation();
  const locale = useSelector(selectLocale);
  const { pageNames: { participant } } = useSelector((state) => state.eventConfigs);
  const [scrollableTarget, setScrollableTarget] = useState();
  const eventName = useSelector(selectLocalizedEventName);
  const pageWrapperRef = useRef();

  useEffect(() => {
    setScrollableTarget(pageWrapperRef.current);
  }, []);

  const pageTitle = participant?.[locale] || t('page.participants', 'Participants');

  return (
    <ScrollableContainerWrapper WrapperContainer={RootContainer}>
      <CustomHelmet>
        <meta charSet="utf-8" />
        <title>{`${pageTitle} | ${eventName}`}</title>
        <meta name="description" content={`${pageTitle} page of ${eventName}.`} />
      </CustomHelmet>
      <PageContentContainer>
        <ParticipantListContainer
          scrollableTarget={scrollableTarget}
        />
      </PageContentContainer>
      <FloatingFooter hashState={Routes.participant} />
    </ScrollableContainerWrapper>
  );
};

export default ParticipantPageContainer;
